<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>
<template>
    <v-dialog v-model="openDialog" max-width="600px">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center">
                {{ message }}
            </v-card-title>
            <v-card-title class="justify-center" v-if='this.$slots.default'> <!-- フィールドが存在するときのみタグを出力する -->
                <slot></slot>
            </v-card-title>
            <v-card-actions class="justify-center">
                <v-btn width="30%" class="white--text mb-8" color="red" x-large @click="pushOk">
                    {{ okBtn }}
                </v-btn>
                <v-btn width="30%" class="white--text mb-8 ml-8" color="blue-grey darken-1" x-large @click="openDialog = false">
                    {{ cancelbtn }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        dialog: Boolean,
        message: String,
        okBtn: String,
        cancelbtn: String,
    },
    computed: {
        openDialog: {
            get() {
                return this.dialog
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:dialog', value);
            }
        },
    },
    methods: {
        pushOk() {
            this.openDialog = false;
            this.$emit('clickOk');
        },
    },
}
</script>